import { Text } from '@netapp/bxp-design-system-react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { memo } from 'react';
import UserMessageStyles from './UserMessage.module.scss';

/**
 * UserMessage - Displays user message aligned to the right
 * 
 * @param {Object} props
 * @param {string} props.id - Unique identifier for the component instance
 * @param {string} props.data - Message content (from descriptor)
 * @param {string} props.message - Message content (direct prop)
 * @param {string} props.className - Additional CSS class
 * @param {function} props.onAction - Callback for actions
 */
const UserMessage = memo(({ id, data, message, className, onAction }) => {
  // Support both 'data' (from descriptor) and 'message' (direct prop)
  const content = data || message;

  return (
    <div
      className={classNames(UserMessageStyles["message-row"], className)}
      data-component-id={id}
    >
      <div className={UserMessageStyles["chat-message-container"]}>
        <Text>{content}</Text>
      </div>
    </div>
  );
});

UserMessage.displayName = 'UserMessage';

// PropTypes for type checking
UserMessage.propTypes = {
  id: PropTypes.string,
  data: PropTypes.string,
  message: PropTypes.string,
  className: PropTypes.string,
  onAction: PropTypes.func
};

UserMessage.defaultProps = {
  id: undefined,
  data: '',
  message: '',
  className: '',
  onAction: undefined
};

// Catalog configuration for registry
UserMessage.catalogConfig = {
  type: 'UserMessage',
  category: 'message',
  defaultProps: {}
};

export default UserMessage;